import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';
import { colors } from '@/Constants/colors';

export const toolChestDefaultConfig: Omit<iStoreCaseConfiguration & { name: string }, 'itemsFromApi'> = {
    name: 'default',
    selectedCaseModel: undefined,
    selectedCasePresetId: undefined,
    blenderName: undefined,
    colorFrame: colors[0].hex,
    colorFace: colors[1].hex,
    caseItems: [],
    drawerSeparators: [],
    expandedDrawersPrototypeId: [],
    isCloseDoors: false,
    isDecoration: false,
};



